module.exports = __webpack_public_path__ + "img/tool_icon2.dea39c75.svg";